import React, { Component } from 'react';
import {NavLink as NavLinkRouter} from 'react-router-dom';
import styles from './SideNavigation.module.scss';

import { connect } from 'react-redux';

/**
 * Import Font Awesome icons
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faRocket, faGamepad, faGraduationCap, faLightbulb, faArrowAltToBottom, faQuestion, faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

import {faGraduationCap as faGraduationCapSolid, faBars} from '@fortawesome/pro-solid-svg-icons';
import {faArrowAltToBottom as faArrowAltToBottomSolid} from '@fortawesome/pro-solid-svg-icons';
import {faQuestion as faQuestionSolid} from '@fortawesome/pro-solid-svg-icons';
import {faLightbulb as faLightbulbSolid} from '@fortawesome/pro-solid-svg-icons';
import {faRobot as faRobotSolid} from '@fortawesome/pro-solid-svg-icons';

/**
 * Import actions
 */

import {
    sidebarToggleOpen,
    sidebarToggleClose
} from 'actions/sidebar/toggle';

const mapDispatchToProps = {
    sidebarToggleOpen,
    sidebarToggleClose
};

const mapStateToProps = (state) => {
    return {
        sidebar: state.sidebar
    };
};


class SideNavigation extends Component {

    constructor(props) {
        super(props);

        // This binding is necessary to make `this` work in the callback
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        if(this.props.sidebar.open) {
            this.props.sidebarToggleClose();
        } else {
            this.props.sidebarToggleOpen();
        }
    }

    render() {
        var isSidebarOpen = this.props.sidebar.open;

        const NavLink = props => (
            <NavLinkRouter {...props} isActive={(match, location) => location.pathname.startsWith(props.to.pathname)}/>
        );

        return (
            <div>
                <div styleName={`container  ${isSidebarOpen ? '' : 'collapsed'}`}>
                    <div styleName="logo">
                        <NavLink styleName="logo" to="" >
                            <img src='/images/svg/goto_logo.svg'></img>
                        </NavLink>
                    </div>
                    <div styleName="link-wrapper">
                        <div styleName='top'>
                            <NavLink to={{pathname:'/lessen'}} activeClassName={styles['active']}>
                                <FontAwesomeIcon icon={faRobotSolid}/>
                                <h5 className="title"> Lessen </h5>
                            </NavLink>
                            <NavLink  to={{pathname:'/inspiratie'}} activeClassName={styles['active']}>
                                <FontAwesomeIcon icon={faLightbulbSolid}/>
                                <h5 className="title"> Inspiratie </h5>
                            </NavLink>
                            
                        </div>
                            <div styleName='bottom'>
                                <NavLink to={{pathname:'/programmeertalen'}} activeClassName={styles['active']} styleName='bottom'>
                                    <FontAwesomeIcon icon={faArrowAltToBottomSolid}/>
                                    <h5 className="title">Downloads</h5>
                                </NavLink>
                                <NavLink to={{pathname:'/vragen'}} activeClassName={styles['active']} styleName='bottom'>
                                    <FontAwesomeIcon icon={faQuestionSolid}/>
                                    <h5 className="title">Vragen</h5>
                                </NavLink>
                            </div>
                    </div>
                    <div styleName="toggle" onClick={this.handleClick}>
                        <div styleName="toggle-icon" >
                            {isSidebarOpen ? <FontAwesomeIcon icon={faArrowLeft}/>  : <FontAwesomeIcon icon={faBars}/>}
                        </div>
                        <h5 className="toggle-title"> </h5>
                    </div>
                </div>
                <div styleName={`background  ${isSidebarOpen ? '' : 'collapsed'}`} onClick={this.handleClick}>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SideNavigation);


// WEBPACK FOOTER //
// ./resources/assets/components/UI/SideNavigation/SideNavigation.jsx